import axios from 'axios';

export const state = {
  trades: [],
  loading: false,
};

export const mutations = {
  setbaaderConfirmingTrades(context, trades) {
    context.trades = trades;
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async fetchBaaderConfirmingTrades({ commit, rootState }, params) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      const query = params ? `?${params}` : '';

      commit('setLoading', true);

      const trades = await axios.get(`${window.BASE_API.TRADING_PLATFORM}/orderbook/status/baader/trades/close${query}`, options)
        .then(response => response.data);

      commit('setbaaderConfirmingTrades', trades);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },

  async updateBaaderTradeState({ commit, rootState, dispatch }, data) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };

      commit('setLoading', true);

      await axios.patch(`${window.BASE_API.TRADING_PLATFORM}/orderbook/status/baader/trades/update`, data, options)
        .then(response => response.data);

      dispatch('fetchBaaderConfirmingTrades');

      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },
};

const baaderConfirmingTradesStore = {
  state,
  mutations,
  actions,
};

export default baaderConfirmingTradesStore;



// WEBPACK FOOTER //
// ./src/store/trades/baaderBankConfirmStore.js